import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import CategoryCards from "./components/CategoryCards";
import BrandShowcase from "./components/BrandShowcase";
import FeaturedArticles from "./components/FeaturedArticles";
import StatsAndTestimonials from "./components/StatsAndTestimonials";
import FAQSection from "./components/FAQSection";
import NewsletterSection from "./components/NewsletterSection";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <article>
          <CategoryCards />
        </article>
        <article>
          <BrandShowcase />
        </article>
        <article>
          <FeaturedArticles />
        </article>
        <article>
          <StatsAndTestimonials />
        </article>
        <article>
          <FAQSection />
        </article>
        <article>
          <NewsletterSection />
        </article>
      </main>
      <Footer />
    </>
  );
}